// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"6bbf7add","180":"e5a68335","288":"7ae7c567","380":"4516ebb6","384":"5e5d25ab","400":"11ff18eb","508":"b888f520","576":"40b27fe6","604":"2db02d8e","640":"208be078","672":"70a5cc0d","736":"f07d72ed","752":"91c5e2e3","799":"b7ad4da6","808":"7de10272","956":"b2564e1d"}[chunkId] + ".chunk.js";
};